
import debounce from 'lodash.debounce';
import {
  AutocompleteFilterStrategy,
  AutocompleteFilterType,
  AutocompleteProperty,
} from './enums';
import AutocompleteProps from './mixins/AutocompleteProps';
import Select from '../select';
import { OptionProperty, SelectProperty } from '../select/enums';
import { ControlEventType } from '../../enums';
import { InputSlotType } from '../../shared/input/enums';
import IconButton from '../../../../icon-button';
import { IconButtonProperty, IconButtonPropsEventType } from '../../../../icon-button/enums';
import { IconType } from '../../../../icon/enums';
import { StyleColorSchemeType, StyleSizeType } from '../../../../../styles/enums';

const AUTOCOMPLETE_CHANGE_INPUT_DELAY = 200;

export default {
  name: 'Autocomplete',
  components: {
    IconButton,
    Select,
  },
  mixins: [AutocompleteProps],
  data() {
    return {
      AutocompleteFilterStrategy,
      AutocompleteProperty,
      ControlEventType,
      SelectProperty,
      InputSlotType,
      IconType,
      IconButtonProperty,
      IconButtonPropsEventType,
      StyleColorSchemeType,
      StyleSizeType,
      searchText: null,
      loadingQuery: [],
    };
  },
  computed: {
    selectInputValue() {
      if (this.searchText !== null) {
        return this.searchText;
      }

      const newSelectInputValue = this.selectedOption?.label;

      if (!newSelectInputValue) {
        return '';
      }

      return newSelectInputValue;
    },
    isSearching() {
      return !!this.loadingQuery.length;
    },
    isSyncStrategy() {
      return this[AutocompleteProperty.FilterStrategy] === AutocompleteFilterStrategy.Sync;
    },
    isAsyncStrategy() {
      return this[AutocompleteProperty.FilterStrategy] === AutocompleteFilterStrategy.Async;
    },
    isStartsWithFilterType() {
      return this[AutocompleteProperty.FilterType] === AutocompleteFilterType.StartsWith;
    },
    selectedOption() {
      return this[AutocompleteProperty.Options].find((option) => (
        option[OptionProperty.Value] === this[AutocompleteProperty.Value]
      ));
    },
    filteredOptions() {
      const options = this[AutocompleteProperty.Options];

      if (this.isAsyncStrategy) {
        return options;
      }

      return this.filterOptions(options);
    },
  },
  methods: {
    addRequestToLoadingQuery(searchText) {
      this.loadingQuery = [...this.loadingQuery, searchText];
    },
    removeRequestFromLoadingQuery(searchText) {
      this.loadingQuery = this.loadingQuery.filter((value) => value !== searchText);
    },
    filterOptions(options) {
      return options.filter((option) => {
        const label = option[OptionProperty.Label].toLowerCase();

        const searchText = this.searchText?.toLowerCase() || '';

        if (this.isStartsWithFilterType) {
          return label.startsWith(searchText.toLowerCase());
        }

        return label.includes(searchText.toLowerCase());
      });
    },
    handleCleanClick() {
      this.searchText = null;
      this.$emit(ControlEventType.Change, null);
    },
    handleSelectBlur() {
      this.searchText = null;
      this.$emit(ControlEventType.Blur);
    },
    handleSelectFocus() {
      this.$emit(ControlEventType.Focus);
    },
    handleSelectChange(value) {
      this.searchText = null;
      this.$emit(ControlEventType.Change, value);
    },
    // eslint-disable-next-line func-names
    triggerSearchHandler: debounce(async function (searchText) {
      this.addRequestToLoadingQuery(searchText);

      try {
        await this[AutocompleteProperty.SearchHandler]?.(searchText);
      } finally {
        this.removeRequestFromLoadingQuery(searchText);
      }
    }, AUTOCOMPLETE_CHANGE_INPUT_DELAY),

    async handleSelectInputChange(searchText) {
      this.searchText = searchText;

      if (this.isSyncStrategy) {
        return;
      }

      await this.triggerSearchHandler(searchText);
    },
  },
};
